import React,{useState} from "react"
import 'bootstrap/dist/css/bootstrap.min.css';
import {Helmet} from "react-helmet"

import LinkButtonTop from '../components/basicComponents/LinkButtonTop'
import Presentazione from '../components/basicComponents/Presentazione'
import JumbotronFooter from '../components/oneTimeComponents/JumbotronFooter'
import Navbar from '../components/oneTimeComponents/NavigationBar'
import AvvisiBando from '../components/basicComponents/AvvisiBando' 
import AvvisoGuida from '../components/basicComponents/AvvisoGuida'
import {Row,Col} from 'react-bootstrap'
import Modal from '../components/Modal/ModalGuidaSito'
import './stile.css'
import Countdown from "../components/ExtraComponents/Countdown";

export default function Home() {
  const [vediModal,setVediModal]=useState(false)

  const presentazioneContent = <div>
    <br/>
    Il Ministero della salute in attuazione degli interventi individuati nell’ambito del programma “Salute-ambiente-biodiversità-clima” del Piano Nazionale per gli investimenti 
    Complementari al Piano Nazionale di Ripresa e Resilienza, ad integrazione dei 13 progetti ammessi al finanziamento con 
    decreto direttoriale del 30 settembre 2022 relativi all’avviso pubblico per la presentazione e selezione di progetti di 
    ricerca applicata “Salute -Ambiente – Biodiversità – Clima”, pubblicato in data 30 giugno 2022, intende promuovere 
    l’investimento 1.4 finanziando 2 progetti relativi a:
    <br/><br/>
    <b>A</b> - Accesso universale all'acqua: approvvigionamento idrico e servizi igienico-sanitari gestiti in sicurezza, uso umano sano e riutilizzo dell'acqua, coste, ambienti marini.<br/>
    <b>B</b> - Prevenzione dei rischi sanitari emergenti associati a cambiamenti ambientali e socio economici, nuove tecnologie, politiche energetiche, trasporti, transizione verde.<br/><br/>
    <b>Dotazione finanziaria</b><br/>
    La dotazione finanziaria complessiva disponibile è di 932.790,90 euro.<br/><br/>
    La news è pubblicata <a href='https://www.pnrr.salute.gov.it/portale/pnrrsalute/dettaglioBandiPNRRSalute.jsp?lingua=italiano&id=351' target='_blank' rel="noopener noreferrer">qui</a> .<br/>
    <br/>L'accesso al sistema è  consentito solo mediante il sistema pubblico di identità digitale {"("}<b>SPID</b>{")"}.<br/>
    <br/>Le richieste di assistenza tecnica dovranno essere effettuate esclusivamente mediante il sistema helpdesk di <a href='https://cbim.freshdesk.com/support/home' target='_blank' rel="noopener noreferrer">CBIM</a>.<br/>
    Prima di sottomettere il ticket si prega di consultare le <a href='https://cbim.freshdesk.com/support/solutions'  target='_blank' rel="noopener noreferrer">FAQ</a>.<br/>
  </div>

  const subImgTimer = <div>
  <Countdown lingua="IT" dataFine={1668898500000} dataFineEstesa={"Sabato 19 Novembre alle ore 23:55"} 
  messaggioCountdown={"La fase di presentazione delle domande terminerà tra "}
  messaggioFine={"La fase di presentazione delle domande è terminata "}
  messaggioDateNull={"La fase di presentazione delle domande terminerà "}
  afterCountdown={"."}
  />
  </div>

  const subImg = <div style={{border:"1px solid black",backgroundColor:"#CCE5FF",padding:"5px"}}>
    É possibile presentare le domande per la selezione di due progetti di ricerca 
    applicata “salute-ambiente-biodiversità-clima” per l’attuazione di interventi da finanziare dell’investimento E.1 “Salute-ambiente-biodiversità-clima” del Piano complementare al Piano nazionale di ripresa e resilienza (PNC-E.1) ,
    la scadenza è il <b>19 Novembre 2022 alle ore 23:55</b>.
    <br/><br/>
    {subImgTimer}
  </div>
  
  return (
    <div className="pageContainer">
        <Helmet>
          <title>Workflow della Prevenzione</title>
        </Helmet>
        <Navbar page="IT" sezione="0"/>
        <LinkButtonTop page="IT"/>
        <br/>
        <Presentazione
          titolo="Bando Piano complementare al PNRR"
          testo={presentazioneContent}
          subImg={subImg}
        />
        <div>
          <Row style={{marginTop:"max(0.5vw,20px)"}} >
            <Col sm={6} xs={12}>
              <AvvisiBando lingua="IT" position="L"/>
            </Col>
            <Col sm={6} xs={12}>
              <AvvisiBando lingua="IT" position="R"/>
            </Col>
          </Row>
        </div>
        {vediModal===true?<Modal chiudiModal={()=>setVediModal(false)}/>:null}
        <JumbotronFooter/>
      </div>
    )
}
